import { gql } from 'apollo-boost';

export const getMutationIdMutation = gql`
    mutation getMutationId($login: String!) {
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;
